import UserChallengeList from './UserChallengeList';

export default UserChallengeList;
